module.exports = __webpack_public_path__ + "img/25.b05f8a0d.svg";